import React, { FC } from 'react';
import PropTypes from 'prop-types';

import { Flex } from '../../../../layouts';
import { Heading } from '../../../../typography';

const DrawerHeaderTitle: FC = ({ children }) => {
  return (
    <Flex justifyContent="center" px="1x_big" flex={1}>
      <Heading weight="medium" type="4" color="neutral.90">
        {children}
      </Heading>
    </Flex>
  );
};

DrawerHeaderTitle.propTypes = {
  children: PropTypes.node,
};

export default DrawerHeaderTitle;
